import React from 'react'
import { Link } from 'react-router-dom'
import Logo from '../../images/logooo.png'
import shape from '../../images/ft-shape.png'
import './Footer.css'
import { FiInstagram } from 'react-icons/fi';


const ClickHandler = () => {
    window.scrollTo(10, 0);
}
const SubmitHandler = (e) => {
    e.preventDefault()
}

const Footer = (props) => {
    return (
        <footer className="wpo-site-footer-s2">
            <div className="wpo-upper-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="widget about-widget">
                                <div className="footer-logo widget-title">
                                    <img src={Logo} width={400} alt="logo" />
                                </div>
                                <p>Endüstriyel Soğuk Zincirde Güvenilir Çözüm Ortağınız</p>
                                <ul>
                                    <li>
                                        <a target="_blank" href="https://www.instagram.com/kuyassogutma?utm_source=qr&igsh=MTJ5ZWRoM2p3bHVrYw==" rel="noreferrer">
                                            <FiInstagram />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>Menü</h3>
                                </div>
                                <ul>
                                    <li><Link onClick={ClickHandler} to="/">Anasayfa</Link></li>
                                    <li><Link onClick={ClickHandler} to="/about">Hakkımızda</Link></li>
                                    <li><Link onClick={ClickHandler} to="/service">Faaliyet Alanlarımız</Link></li>
                                    <li><Link onClick={ClickHandler} to="/contact">İletişim</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="widget contact-widget">
                                <div className="widget-title">
                                    <h3>İletişim</h3>
                                </div>
                                <ul className="contact-info-s2">
                                    <li>
                                        <i className="ti-location-pin"></i>
                                        <p>Güzelevler Mh Şehit J. Er Gökhan Yılmaz Cd no 2 iç kapı C Yüreğir/ADANA</p>
                                    </li>
                                    <li>
                                        <i className="ti-mobile"></i>
                                        <p>
                                            <a target="_blank" href="tel:+905333013985" rel="noreferrer">
                                                +90533 301 39 85
                                            </a>
                                        </p>
                                    </li>
                                    <li>
                                        <i className="ti-email"></i>
                                        <p><a href="mailto:kuyassogutma@gmail.com">kuyassogutma@gmail.com</a></p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ft-shape">
                    <img src={shape} alt="shape" />
                </div>
                <div className="ft-shape-s1">
                    <svg width="154.000000pt" height="257.000000pt" viewBox="0 0 254.000000 257.000000"
                        preserveAspectRatio="xMidYMid meet">
                        <g transform="translate(0.000000,257.000000) scale(0.100000,-0.100000)" stroke="none">
                            <path d="M0 1341 c0 -1111 2 -1229 16 -1235 8 -3 56 -11 104 -16 206 -23 368 38 504 191 26 30 135 185 241 344 217 326 264 388 403 529 159 162 348 309 592 461 179 112 349 228 405 277 72 63 132 151 156 226 16 54 20 93 20 202 1 80 -5 157 -13 190 l-13 55 -1208 3 -1207 2 0 -1229z" />
                        </g>
                    </svg>
                </div>
                <div className="ft-shape-s2">
                    <svg width="230.000000pt" height="197.000000pt"
                        viewBox="0 0 230.000000 197.000000" preserveAspectRatio="xMidYMid meet">
                        <g transform="translate(0.000000,197.000000) scale(0.100000,-0.100000)" stroke="none">
                            <path d="M1885 1463 c-189 -11 -392 -50 -565 -109 -202 -68 -460 -209 -630 -345 -222 -176 -436 -441 -560 -694 -45 -91 -120 -283 -120 -305 0 -6 428 -10 1145 -10 l1145 0 0 719 c0 677 -1 720 -17 725 -25 8 -268 26 -312 24 -20 -1 -58 -3 -86 -5z" />
                        </g>
                    </svg>
                </div>
            </div>
            <div className="wpo-lower-footer">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col col-lg-12 col-md-12 col-12">
                            <div className="copyright text-center">
                                <p>Copyright @ 2026 Powered By <a href="https://www.janberkaltay.dev/" target="_blank" rel="noopener noreferrer">Janberk ALTAY</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;